export default {
  module_title: '機器人平臺',
  messages: {
    license_fail_message: '獲取License信息失敗',
    org_fail_message: '獲取組織列表失敗',
    product_fail_message: '獲取使用者產品列表失敗',
    role_user_cannot_delete_message: '當前角色已分配使用者不可以刪除。可取消當前角色的分配，然後刪除角色',
    org_cannot_empty_msg: '組織名稱不能為空',
    org_exist_msg: '組織名稱已經存在',
    upper_org_cannot_be_empty: '上級組織不能為空',
    status_cannote_be_empty: '狀態不能為空',
    role_empty_message: '角色名不能為空',
    source_empty_message: '資料來源不能為空',
    check_delete_user: '角色{user}已存在',
    no_product_msg: '該組織下暫未分配產品',
    no_selected_org: '尚未選擇組織',
  },
  general: {
    place_holder: '輸入關鍵字搜尋',
    hide: '隱藏',
    system_name_default: 'Bot factory',
    enter: '進入',
    platform_name: '機器人平臺',
    range: '區間',
    confirm: '確認',
    name: '名稱',
    image: '圖片',
    icon: '圖示',
    clear_all: '清除全部',
    reset_to_default: '還原預設',
    pink_all: '選擇全部',
    view: '檢視',
    custom_column: '自定義欄位',
    default_column: '預設欄位',
    enable: '啟用',
    disable: '停用',
    setting: '設定',
    language: '語言',
    zh_tw: '繁體中文',
    zh_cn: '簡體中文',
    us_en: '英文',
    delete_success: '刪除成功',
    robot_list: '機器人列表',
    im: 'IM',
    no_data: '暫無資料',
    no_search_data: '暫無查詢結果',
    no_option: '無選項',
    no_filterable_option: '無篩選結果',
    clearchecked: '刪除所選項',
    reset: '重置',
    chat_test: '功能檢測',
    custom: '自定義',
    yes: '是',
    no: '否',
    empty: '無',
    operation: '操作',
    search: '查詢',
    all: '全部',
    add: '新增',
    actions: '操作',
    status: '狀態',
    edit: '編輯',
    delete: '刪除',
    remove: '移除',
    question: '問題',
    answer: '答案',
    ext_answer: '答案擴充套件',
    ok: '確認',
    cancel: '取消',
    canceled: '已取消',
    confirm_edit: '確認修改',
    already_cancel: '已取消',
    loading: '頁面載入中',
    table_loading: '表格載入中...',
    error_code: '錯誤程式碼',
    error: '錯誤',
    upload: '上傳',
    browse: '瀏覽',
    copy: '複製',
    save: '儲存',
    saving: '儲存中',
    default: '預設',
    indicate: '指定',
    force_cancel: '強制取消',
    import: '匯入',
    export: '匯出',
    success: '成功',
    fail: '失敗',
    description: '提示',
    file: '檔案',
    finish: '完成',
    folder: '目錄',
    search_placeholder: '請輸入搜尋內容',
    close: '關閉',
    test: '測試',
    modify: '修改',
    save_change: '儲存變更',
    go_back: '返回',
    please_choose: '請選擇',
    intent: '意圖',
    select_all: '全選',
    download: '下載',
    batch_import: '批量匯入',
    unit1: '條',
    unit2: '個',
    start_date: '開始時間',
    end_date: '結束時間',
    batch_upload: {
      only_xlsx_xls: '僅支援xlsx，xls格式檔案',
      file_invalid: '檔案驗證錯誤',
      upload_file: '上傳檔案',
      choose_file: '選擇檔案',
      download_template: '下載模板',
      upload_mode: '上傳模式',
      add_data: '新增資料',
      add_data_desc: '只新增沒有重複且有效的資料',
      replace_all: '全量替換',
      replace_all_desc: '全量替換會先刪除當前所有資料，再上傳檔案的資料。請謹慎操作，注意資料備份',
      tip: '注意事項',
      tips: '1. 支援xlsx的檔案格式進行上傳</br>2. 請參考模板中的文件說明，按照照格式填寫 </br>3. 全量替換將替換掉所有資料且無法回覆，建議先備份資料',
      empty_file: '上傳的內容為空, 請重新選擇檔案!',
      oversize_file: '上傳的行數不可超過%1行',
      confirm_upload: '確認匯入',
    },
    export_all: {
      title: '資料匯出',
      export_current: '匯出當前資料',
      upload_history: '匯入歷史',
      history_count: '只保留近%d次匯入資料',
      file_name: '文件名稱',
      upload_time: '上傳時間',
      action: '操作',
      download: '下載',
      download_error: '錯誤報告',
      status: '狀態',
      upload_success: '匯入成功',
      upload_fail: '匯入失敗',
      file_replaced: '檔案被覆蓋',
      no_sheet_file: '上傳檔案中找不到目標頁',
      invalid_templ_version: '匯入模板版本不適配',
      part_success: '部分匯入成功',
      upload_type: '上傳模式',
      add_mode: '增量',
      replace_mode: '全量',
    },
    log_off: '登出',
    load_more: '載入更多',
    note: '注意',
    detail: '詳情',
    license_expired: '許可證已過期,請聯絡管理員',
    edit_success: '操作成功',
    serial: '序號',
    pending: '載入中...',
    normal: '正常',
    abnormal: '異常',
    total: '共{total}條',
    uploading: '檔案上傳中...',
    dataLoading: '資料載入中...',
    switch: '開關',
    ok_modify: '確定修改',
    ok_add: '確定新增',
    tempLoading: '模版獲取中...',
    line_wrap: '強制換行',
    on: '開',
    off: '關',
    load_temp: '載入模版',
    batch_delete: '批量刪除',
    reload: '重新整理',
    open_filter: '高階',
    close_filter: '收起',
    copied: '複製成功',
    license_probation_expired: '已過試用期，請聯絡管理員申請許可證',
  },
  management: {
    role_add_success: '角色新增成功',
    role_add_fail: '角色新增失敗',
    role_update_success: '角色更新成功',
    role_update_fail: '角色更新失敗',
    role_delete_success: '角色刪除成功',
    role_delete_fail: '角色刪除失敗',
    user_has_no_role: '該使用者尚未分配角色',
    no_active_org: '當前沒有可選擇的啟用組織',
    user_amount: '使用者數量',
    product: '產品',
    add_position: '新增角色',
    role_manage: '角色許可權管理',
    basic_info: '基本資訊',
    admin_account: '系統管理員賬號',
    position_edit: '編輯角色',
    position_add: '新增角色',
    position_name: '角色名稱',
    please_enter_position_name: '請輸入角色名稱',
    data_auth: '資料許可權',
    data_source: '資料來源',
    please_choose_data_source: '請選擇資料來源',
    please_choose_data_source_sub_type: '請選擇資料來源子類型',
    operation_right: '操作許可權',
    ccbot_auth_operate: '外呼平臺許可權配置',
    to_ccbot_auth_operate: '進入外呼平臺許可權配置',
    no_interrupt_tip: '進入後不會影響當前其他平臺的配置操作',
    all_access_user: '該使用者可以使用該產品的全部功能',
    add_confirm: '確認新增',
    basic_info_setting: '基本資訊設定',
    update_confirm: '確定編輯',
    role_assign: '分配角色',
    enable: '啟用',
    enabled: '已啟用',
    disable: '禁用',
    disabled: '已禁用',
    encrypt_title: '機器人匯出加密設定',
    encrypt_tips: '請為此檔案設定密碼',
    file_pwd: '檔案密碼',
    file_pwd_confirm: '確認密碼',
    file_pwd_placeholder: '請輸入檔案密碼',
    file_pwd_confirm_placeholder: '確認密碼',
    confirm_export: '確定並匯出',
    import_encrypt_title: '機器人匯入',
    import_encrypt_tips: '此檔案已加密，請輸入檔案密碼',
    import_pwd_tips: '若忘記密碼請聯絡管理員或重新匯出檔案',
    confirm_import: '確定並匯入',
    pwd_empty: '密碼和確認密碼都不能為空',
    pwd_error: '密碼不一致',
    pwd_reg_tips: '請輸入6-16位的數字或者英文',
    exporting_msg: '正在匯出中，請稍等~',
    import_err_msg: '匯入失敗！{message}',
    import_moudule_err_msg: '因 {messaeg} 模組匯入失敗',
    robot_group_placeholder: '搜尋機器人群組',
    robot_list_placeholder: '搜尋機器人',
    import_robot: '匯入機器人',
    total_robot_message: 'hi {name}, 您已建立{num}個機器人',
    open: '已啓用',
    un_use: '未啓用',
    add_enterprise_success: '企業添加成功',
    add_enterprise_fail: '企業添加失敗',
    edit_enterprise_success: '企業修改成功',
    enterprise_setting: '企業設定',
    organization_list: '企業組織',
    enterprise_status: '企業狀態',
    enterprise_search_text: '輸入企業名稱搜尋',
    user_management: '使用者管理',
    role_list: '角色許可權',
    icon_setting: '圖示設定',
    enterprise_icon_setting: '企業圖示設定',
    enterprise_lu_icon: '企業左上圖示',
    enterprise_lu_icon_info: '支援格式 svg, png，檔案大小限制為 1mb，建議圖片大小22px*22px',
    browser_page_icon: '瀏覽器頁籤',
    browser_page_icon_info: '支援格式 png ，檔案大小限制為1mb，建議寬高比例20px*20px',
    table_robot_list: '機器人列表',
    table_group_name: '群組名稱',
    robot_template: '機器人模板',
    return_to_robot_list: '返回機器人列表',
    import_robot_running: '機器人正在匯入中...',
    import_robot_time: '預計需要10分鐘',
    create_from_template: '從模板建立',
    list_robot_name: '機器人',
    operate: '操作',
    upload_wating: '當前匯入任務還未完成，請等待任務完成後再操作',
    upload_success: '匯入成功',
    export_wating: '當前有機器人正在匯出請稍等',
    faq_count: '標準問答：',
    te_count: '任務場景：',
    system_setting: '系統設定',
    gatway_setting: '落地閘道器設定',
    inbound_and_scenario_setting: '呼入路由及場景配置',

    icon_management: '圖示管理',
    system_icon_setting: '系統圖示設定',
    system_lu_icon: '系統左上圖示',
    login_icon: '登入畫面圖示',
    login_icon_info: '支援格式 svg,png ，檔案大小限制為1mb，建議檔案大小 320px*45px',
    group_name: '群組名稱',
    enterprise_list: '企業管理',
    admin_list: '管理員設定',
    enterprise: '企業',
    create_enterprise: '建立企業',
    delete_enterprise: '刪除企業',
    edit_enterprise: '編輯企業',
    create_time: '建立時間',

    enterprise_name: '企業名稱',
    enterprise_description: '企業描述',
    module_list: '功能列表',
    product_list: '該企業可以使用以下產品',

    system_admin_list: '系統管理人員',
    system_admin_desc: '建立企業時，必須指定一位企業管理人員',

    robot_group: '機器人群組',
    robots: '機器人',
    robot_list: '機器人列表',

    create_robot: '建立新機器人',
    delete_robot: '刪除機器人',
    edit_robot: '編輯機器人',
    group_manage: '機器人群組管理',

    robot_name: '機器人名字',
    description: '描述',
    no_description: '無描述資訊',
    input_placeholder: '輸入文字',
    length_50_placeholder: '字數限制50內',
    chat_language: '對話語言',

    create_group: '建立群組',
    edit_group: '修改群組',
    delete_group: '刪除群組',
    add_robot: '加入機器人',
    input_personal_pass: '輸入個人密碼',
    reason_description: '原因描述',

    user_preference: '個人資料',
    edit_data: '修改資料',
    edit_user_preference: '修改個人資料',

    enterprise_privilege_manage: '企業許可權管理',
    add_account: '新增帳號',
    edit_account: '編輯人員',
    add_role: '新增許可權',
    privilege_setting: '許可權設定',
    role_name_placeholder: '輸入角色名稱',
    normal_user: '一般使用者',
    enterprise_admin: '企業管理員',
    system_admin: '系統管理員',
    unknown: '未知',

    user_name: 'ID',
    user_type: '帳號類型',
    user_display_name: '姓名',
    phone: '聯絡電話',
    email: 'Email',
    next_step: '下一步',
    last_step: '上一步',
    password: '密碼',
    set_password: '設定密碼',
    check_password: '確認密碼',
    modify_password: '修改密碼',
    set_passowrd_placeholder: '請輸入密碼',
    set_right_origin_pwd: '請輸入正確的舊密碼',
    check_password_placeholder: '再輸入一次密碼',
    assign_robot: '指定機器人',
    privilege_is: '許可權為',

    manager_password: '管理員密碼',
    orig_password: '原密碼',
    new_password: '新密碼',
    check_new_password: '確認新密碼',
    password_format: '介於6~16字的英文字母、數字或符號，須包含大小寫英文字母與數字',
    username_format: '介於4~64字的英文字母、數字或 @._-',
    err_empty_username: 'ID 不可為空',
    err_existed_username: 'ID 已存在',
    err_username_length: 'ID 長度需介於4~64字之間',
    err_invalid_username: '不合法的 ID 格式',
    err_empty_email: 'Email 不可為空',
    err_invalid_email: '不合法的 Email 格式',
    err_invalid_phone: '不合法的電話格式',
    err_empty_display_name: '姓名不可為空',
    err_display_name_length: '姓名長度需介於2~50字之間',
    err_password_length: '密碼長度需介於6~16字之間',
    err_password_invalid: '不合法的密碼格式',
    err_password: '密碼錯誤',
    err_origin_password: '原密碼錯誤',
    err_manager_password: '管理員密碼錯誤',
    err_manager_empty_password: '管理員密碼不可為空',
    err_origin_empty_password: '原密碼不可為空',
    err_invalid_check_password: '兩次密碼輸入不同',
    update_password_success: '更新密碼成功',
    add_user_success: '新增使用者成功',
    err_update_password_fail: '更新密碼失敗',
    err_role_duplicate: '角色名稱已存在',
    err_robot_name_empty: '機器人名稱不可為空',
    err_robot_duplicate: '機器人名稱已存在',
    err_enterprise_name_empty: '企業名稱長度需介於1~50字之間',
    err_enterprise_duplicate: '企業名稱已存在',

    err_group_name_empty: '群組名稱不可為空',
    err_group_duplicate: '群組名稱已存在',
    err_pick_no_modules: '功能列表至少需勾選一個',
    err_reason_empty: '刪除原因不可為空',
    err_enterprise_admin_duplicate: '企業管理員帳號名已存在',
    err_enterprise_email_duplicate: '企業管理員信箱已存在',
    err_unkown: '發生未知錯誤',
    err_add_robot_fail: '新增機器人失敗',
    err_add_robot_fail_license: '授權機器人數量已用完',
    go_back: '返回',
    audit: {
      system: '系統操作記錄',
      enterprise: '企業操作記錄',
      robot: '機器人操作記錄',
      filter_time: '發生時間',
      filter_robot: '機器人',
      filter_module: '操作模組和類型',
      filter_userid: '使用者ID',
      filter_enterprise: '企業',
      total: '共 {num} 條',
    },
    privilege: {
      statistic_dash: {
        view: '統計概覽',
      },
      ssm: {
        view: '常用標準問答檢視',
        edit: '常用標準問答編輯',
        export: '常用標準問答匯出',
        import: '常用標準問答匯入',
      },
      qa_label: {
        view: '標籤管理檢視',
        edit: '標籤管理編輯',
      },
      ssm3: {
        view: '檢視標準問答',
        import: '匯入資料',
        export: '匯出資料',
        'create-sq': '手動新增標準問答',
        'del-sq': '刪除標準問題',
        'edit-sq': '編輯標準問題',
        'edit-answer': '編輯回答',
        'edit-lq': '編輯語料',
        train: '訓練資料',
        test: '測試及報告',
        publish: '釋出上線',
        'edit-label': '管理標籤',
      },
      qa_records: {
        view: '稽覈變更',
      },
      task_engine: {
        edit: '任務引擎編輯',
      },
      wordbank: {
        view: '檢視',
        edit: '編輯',
        create: '新增',
        delete: '刪除',
        import: '匯入',
        export: '匯出',
      },
      statistic_analysis: {
        view: '統計分析檢視',
        export: '統計分析匯出',
      },
      statistic_daily: {
        view: '日誌管理檢視',
        export: '日誌管理匯出',
      },
      statistic_audit: {
        view: '操作記錄檢視',
        export: '操作記錄匯出',
      },
      robot_profile: {
        view: '機器人形象檢視',
        edit: '機器人形象編輯',
      },
      robot_chat_skill: {
        view: '話術設定檢視',
        edit: '話術設定編輯',
      },
      robot_function: {
        view: '技能設定檢視',
        edit: '技能設定編輯',
      },
      robot_command: {
        view: '指令設定檢視',
        edit: '指令設定編輯',
      },
      intent_manage: {
        view: '意圖管理檢視',
        edit: '意圖管理編輯',
        export: '意圖管理匯出',
        import: '意圖管理匯入',
      },
      integration: {
        view: '接入部署檢視',
        edit: '接入部署編輯',
      },
      robot_config: {
        view: '機器人設定檢視',
        edit: '機器人設定變更',
      },
      ner_factory: {
        view: '檢視',
        edit: '編輯',
        create: '新增',
        delete: '刪除',
        import: '匯入',
        export: '匯出',
      },
      domain_kg: {
        view: '知識推理引擎檢視',
        edit: '知識推理引擎編輯',
        delete: '知識推理引擎刪除',
        import: '知識推理引擎匯入',
      },
      health_check: {
        view: '檢視健康檢查',
        edit: '編輯健康檢查',
      },
    },
    org: {
      all_org: '全部組織',
      businessOrgan_list: '企業組織',
      treeTitle: '組織關係',
      rightHeader: '組織列表 - ',
      rightStatus: '組織狀態',
      placeholder: '輸入文字，回車搜尋',
      addOrg: '新建組織',
      tableName: '組織名稱',
      tableUp: '上級組織',
      tablePro: '可用產品',
      tableStatus: '狀態',
      tableOr: '操作',
      editOrg: '編輯組織',
      confirm: '確定建立',
      editSure: '確定修改',
      editStatus: '狀態修改成功',
      popup: {
        title: '基本資訊',
        orgName: '組織名稱',
        orgUp: '上級組織',
        status: '狀態',
        product: '該組織可以使用以下產品',
        placeholder: '輸入組織名稱',
        addSuccess: '新建組織成功',
        upSuccess: '修改組織成功',
      },
    },
    userManage: {
      userManage_list: '使用者管理',
      rightHeader: '使用者賬號管理',
      rightOrg: '所屬組織',
      rightStatus: '使用者狀態',
      addAccount: '新增賬號',
      name: ' 使用者名稱',
      accountType: '賬號類型',
      lastName: '姓名',
      phone: '聯絡電話',
      Email: 'Email',
      ownerOrg: '所屬組織',
      siblingOrg: '關聯組織',
      status: '狀態',
      operate: ' 操作',
      placeholder: '輸入文字，回車搜尋',
      userType: '開始建立',
      addSuccess: '新建使用者成功',
      upSuccess: '修改使用者成功',
      popup: {
        adduser: '新增賬號',
        edituser: '編輯賬號',
        confirm: '確定建立',
        editSure: '確定修改',
        account: '賬號資訊',
        username: '使用者名稱',
        name: '姓名',
        phone: '聯絡電話',
        Email: 'Email',
        password: '設定密碼',
        updatePw: '新密碼',
        updateSurePw: '確認新密碼',
        surePassword: '確認密碼',
        adminPw: '管理員密碼',
        status: '使用者狀態',
        ownerOrg: '所屬組織',
        siblingOrg: '關聯組織',
        guest: '一般使用者',
        admin: '企業管理員',
        placeholder: '請選擇',
        placeholderUser: '請輸入使用者名稱',
        placeholderName: '請輸入姓名',
        placeholderPhone: '請輸入聯絡電話',
        placeholderEmail: '請輸入聯絡郵箱地址',
        placeholderAdmin: '請輸入管理員密碼',
        placeholderPs: '請輸入要設定的密碼',
        placeholderSureMsg: '請再次輸入密碼',
        password_format: '介於6~16字的英文字母、數字或符號，須包含大小寫英文字母與數字',
        username_format: '介於4~64字的英文字母、數字或 @._-',
        sectionTitle: '角色分配',
        robot: '指定機器人',
        roles: '角色',
        addButton: '新增指定機器人',
        addRoleButton: '新增指定角色',
        noRobot: '暫不支援角色分配',
      },
    },
    model_management: '模型管理',
  },
  privileges: {
    role: '角色',
    user: '使用者',
    password: '密碼',
    role_name: '角色名',
    user_name: '使用者名稱',
    privileges: '許可權',
    user_count: '使用者數',
    function_priv: '功能許可權',

    placeholder_user_name: '請輸入使用者名稱',
    placeholder_password: '請輸入密碼',
    placeholder_modify_password: '若要變更則輸入密碼',
    placeholder_input_role_name: '請輸入角色名',

    enterprise_admin: '企業管理員',

    no_roles: '無角色存在',
    no_users: '無使用者存在',
    all_active: '開啟全部',
    all_deactive: '關閉全部',

    check_delete: '確認要刪除角色：{role}',
    check_delete_user: '確認要刪除使用者：{user}',
    check_cancel_user: '確認要登出使用者：{user}',
    delete_success: '刪除成功',
    err_need_create_role: '請先新增角色',
    err_role_empty: '角色不可為空',

    actions: {
      edit: '編輯',
      view: '檢視',
      create: '新增',
      delete: '刪除',
      export: '匯出',
      import: '匯入',
      login: '登入',
      logout: '登出',
      publish: '釋出',
      active: '啟動',
      deactive: '關閉',
      train: '訓練',
      revert: '回退',
      sync: '同步',
      mark: '標註',
      ignore: '忽略',
      cluster: '輔助分類',
      sq_add: '新增標準問題',
      sq_edit: '修改標準問題',
      sq_delete: '刪除標準問題',
      sq_import: '上傳標準問題',
      sq_publish: '標準問題釋出',
      lq_add: '新增語料',
      lq_edit: '儲存/修改擴寫',
      lq_delete: '刪除語料',
      lq_import: '上傳語料',
      ans_add: '新增回答',
      ans_edit: '編輯回答',
      test_import: '上傳測試題',
    },

    modules: {
      statistic_dash: '統計概覽',
      statistic_analysis: '統計分析',
      statistic_daily: '日誌管理',
      statistic_audit: '操作記錄',
      statistic_heatlh_check: '健康檢查',

      ssm: '常用標準問題',
      qa_label: '標籤管理',
      ssm3: '常用標準問題',
      qa_records: '稽覈變更',
      domain_kg: '知識推理引擎',
      health_check: '健康檢查',
      ccs_config: '中控系統',

      qalist: '問答庫',
      qatest: '對話測試',
      qa_chat_skill: '話術設定',
      qa_rule: '規則管理',

      robot_profile: '機器人形象',
      robot_chat_skill: '話術設定',
      robot_function: '技能設定',
      robot_command: '指令設定',
      robot_config: '機器人設定',
      wordbank: '詞庫',
      task_engine: '任務引擎',

      management: '許可權管理',
      intent_manage: '意圖引擎',
      integration: '接入部署',
      chat_test_tools: '對話測試',
      material: '素材庫',
    },
    tools: {
      encrypt: {
        title: '加密工具',
        button: '加密',
        copy_button: '複製',
        placeholder: {
          encrypt_from: '輸入欲加密的文字',
          encrypt_to: '加密結果會顯示在這裡',
        },
        fail: '加密失敗',
        copied: '已複製加密文字',
      },
    },
  },
  pages: {
    null: '',
    manage_admin: {
      module_name: '系統管理人員',
    },
    manage_enterprise: {
      module_name: '企業列表',
    },
    manage_user: {
      module_name: '企業使用者管理',
    },
    manage_robot: {
      module_name: '機器人列表',
    },
    status: {
      module_name: '資料總覽',
      statistic_dash: '統計概覽',
    },
    ccs: {
      module_name: '對話管理',
    },
    ssm: {
      module_name: '問答管理',
      ssm: '常用標準問題',
      qa_label: '標籤管理',
      history: '變更記錄',
    },
    chat_tools: {
      module_name: '工具',
      chat: '對話測試工具',
    },
    privileges: {
      module_name: '許可權管理',
      role_manage: '角色管理',
      user_manage: '使用者管理',
      other_tools: '其他工具',
    },
    robot_setting: {
      module_name: '機器人設定',
      robot_profile: '機器人形象',
      robot_function: '技能設定',
      robot_chat_skill: '話術設定',
      robot_command: '指令設定',
      integration: '接入部署',
      robot_config: '系統功能配置',
      message: '如果您設定了多個回答，你的機器人會隨機選擇一個回答進行回覆。\n' +
        '如果您對回答設定了維度，則該回答只能在指定維度上應用；無設定則為全維度範圍應用。',
      check_other_question: '檢視其他問法',
      add_answer: '增加回答',
      edit_answer: '回答編輯',
      edit_question: '問法編輯',
      other_question: '你希望這個問題有什麼其他的問法？',
      add_question: '新增問法',
      cancel: '取消',
      add: '新增',
      no_question: '暫無其他問法',
      save: '確定儲存',
      confirm_modification: '確定修改',
      quit_modification: '放棄修改',
      err_empty_robot: '回答內容不能為空',
      demo_question: '示例問法',
      hotspot_issues: '熱點問題配置',
    },
    wordbank: {
      module_name: '詞庫',
      wordbank_list: '詞庫關係',
      wordbank_upload: '詞庫匯入',
    },
    faq: {
      module_name: '問答管理',
      qalist: '問答庫',
      qa_greeting: '寒暄庫',
      qatest: '對話測試',
      qa_chat_skill: '話術設定',
      qa_label: '標籤管理',
      qa_rule: '規則管理',
      qa_learning: '自學習',
    },
    statistics: {
      module_name: '對話資料',
      statistic_analysis: '統計分析',
      statistic_daily: '日誌管理',
      statistic_audit: '操作記錄',
      statistic_learning: '負反饋',
      statistic_session: '會話日誌',
      statistic_heatlh_check: '健康檢查',
    },
    task_engine: {
      module_name: '任務引擎',
      task_engine_scenario: '場景列表',
      task_engine_scenario_v2: '場景列表',
      task_engine_scenario_v3: 'TDE場景列表',
      task_engine_upload: '上傳轉換資料',
    },
    knowledge_graph: {
      module_name: '知識推理引擎',
      property_manage: '屬性管理',
      relation_manage: '實體管理',
      material_manage: '變更稽覈',
      test_report: '測試報告',
      data_manage: '資料管理',
    },
    intent_engine: {
      module_name: '意圖引擎',
      intent_manage: '意圖管理',
      intent_manage_old: '舊意圖管理',
      intent_test: '意圖測試',
    },
    ner: {
      module_name: '自定義解析器',
      ner_extractor: '抽取器',
      ner_wordbank_upload: '詞庫匯入',
      ner_test_report: '測試及報告',
    },
    material: {
      module_name: '多媒體庫',
      manage: '素材管理',
    },
    manage_model: {
      module_name: '模型管理',
    },
    error: '',
  },
  statistics: {
    day: '天',
    export_mode: '高階',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/zh-tw.js